import museumSVG from 'iovisit-museum-theme/icons/museum.svg';
import roomSVG from 'iovisit-museum-theme/icons/sala.svg';
import operaSVG from 'iovisit-museum-theme/icons/opera.svg';
import vrSVG from 'iovisit-museum-theme/icons/vr.svg';

import { Logo, LogoFooter } from 'iovisit-museum-theme/components/layout';
import {
  IoVisitMuseumViews,
  IoVisitMuseumBlocks,
} from 'iovisit-museum-theme/config';

import { searchFiltersArtworks } from 'iovisit-museum-theme/reducers';

export default function applyConfig(config) {
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['it', 'en'];
  config.settings.iovisit.siteName = 'IO Museo';
  config.settings.iovisit.logo = Logo;
  config.settings.iovisit.logoFooter = LogoFooter;
  config.settings.iovisit.contentTypeSiteIcons = {
    ...config.settings.iovisit.contentTypeSiteIcons,
    Museum: { prefix: 'fas', name: 'landmark' },
    Room: { prefix: 'fas', name: 'kaaba' },
    Artwork: { prefix: 'fas', name: 'monument' },
  };

  // config.settings.iovisit.topLink = {
  //   text: 'Comune di Montechiarugolo',
  //   url: 'https://www.comune.montechiarugolo.pr.it/',
  // };

  IoVisitMuseumViews(config);
  IoVisitMuseumBlocks(config);

  config.settings.contentIcons = {
    ...config.settings.contentIcons,
    Museum: museumSVG,
    Room: roomSVG,
    Artwork: operaSVG,
    Image360: vrSVG,
  };

  config.addonReducers = {
    ...config.addonReducers,
    searchFiltersArtworks,
  };

  return config;
}
